import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {SearchRequestService} from '../../shared/service/search-request.service';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {Router} from '@angular/router';
import swal from "sweetalert2";
import {SearchRequestDetailModel} from '../../shared/dto/search-request-detail.model';
import {SearchRequestModel} from '../../shared/dto/search-request.model';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {WorkFlowStageModel} from '../../shared/dto/work-flow-stage-model';

@Component({
  selector: 'app-request-search',
  templateUrl: './request-search.component.html',
  styleUrls: ['./request-search.component.scss']
})
export class RequestSearchComponent implements OnInit, AfterViewInit {
  public dateTimeRange: Date[]=[];
  public requestForm: FormGroup;
  public dto: SearchRequestModel[] = [];
  public max = new Date();
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  displayedColumns: string[] = ['requestId', 'applicantType', 'name','mobileNo', 'cdcNo' ,'cocNo','date','status', 'action'];
  dataSource: MatTableDataSource<any>;
  public item : SearchRequestModel[] = [];
  public workflowList: WorkFlowStageModel[]=[];

  constructor(private searcRequestService:SearchRequestService,
              public tokenStorageService: TokenStorageService,
              private spinnerService: NgxUiLoaderService,
              private router : Router) { }

  ngOnInit() {
    this.requestForm = new FormGroup({
      refNo: new FormControl(null),
      cdcNo: new FormControl(null),
      cocNo: new FormControl(null),
      sidNo: new FormControl(null),
      dateTimeRange: new FormControl(null),
      status: new FormControl(null),
      biometricStatus: new FormControl(null),
      dataverification: new FormControl(null)
    });

    this.loadAllRequests();
    this.loadAllWorkflows();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  loadAllWorkflows(){

    this.searcRequestService.getAllWorkflows().subscribe(
      (data: WorkFlowStageModel[])=>{
        this.workflowList = data;
      }
    );
  }

  loadAllRequests() {
    this.searcRequestService.getAllRequests().subscribe(
      (data: SearchRequestModel[]) => {
        this.dto = data;
        this.item = data;
        this.dataSource = new MatTableDataSource(this.dto);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    )
  }

  onClickReset() {
    this.requestForm.reset({
      refNo: null,
      cdcNo: null,
      cocNo: null,
      dateTimeRange: [],
    });
    this.loadAllRequests();
  }

  onSubmitSearch(form: FormGroup) {
    const searchRequestDTOS =  new SearchRequestDetailModel(form.value.refNo ,form.value.cdcNo , form.value.cocNo , form.value.dateTimeRange, form.value.status, form.value.biometricStatus, form.value.dataverification,form.value.sidNo);
    this.loadSearchResultList(searchRequestDTOS);
  }

  exportPDF(){
    this.spinnerService.start();
    this.searcRequestService.exportAsPDF(this.dto).subscribe(
      (data:any) =>{
        console.log("This Data " + data);
        const file = new Blob([data], {type:'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank");
      }, error => {
        this.spinnerService.stop();
        console.log(error);
      }
    );
    this.spinnerService.stop();
  }

  loadSearchResultList(searchRequestDTO: SearchRequestDetailModel): void {
    this.spinnerService.start();
    this.searcRequestService.searchRequestDetails(searchRequestDTO).subscribe(
      (data: SearchRequestModel[]) => {
        this.dto = data;
        this.dataSource = new MatTableDataSource(this.dto);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();
        if (this.dto == null || this.dto.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');
          this.loadAllRequests();
        } else {
          this.searcRequestService.clearRequestSearchDetails();
          this.searcRequestService.setRequestSearchDetails(
            this.dto
          );
        }
      }
    );
  }

  exportAsExcel() {
    this.spinnerService.start();
    this.searcRequestService.exportAsExcel(this.dto).subscribe(
      (data:any) =>{
        console.log("This Data " + data);
        const file = new Blob([data], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank");
      }, error => {
        this.spinnerService.stop();
        console.log(error);
      }
    );
    this.spinnerService.stop();
  }
}
